export const Sizes = {
  ContainerBaseWidth: 1600,
  ContainerCompactWidth: 960,
  HeaderHeight: 90,
};
